import React, { Component } from "react";
import PropTypes from "prop-types";
import {
  Row,
  Col,
  Button,
  FormGroup,
  FormControl,
  ControlLabel,
  Alert
} from "react-bootstrap";
import { withRouter } from "react-router";
import { connect } from "react-redux";
import { bindActionCreators, compose } from "redux";
import { createHashHistory } from "history";
import { Breadcrumb as BreadcrumbComponent } from "../../../components";
import "../../../style/subAdmin/SubAdmin.scss";
import isEmpty from "lodash.isempty";
import { renderAlert, clearAlert } from "../../../redux/actions/alertsActions";
import { getDealDetail } from "../../../redux/actions/dealActions";
import moment from "moment";
import { StaticGoogleMap, Marker, Path } from "react-static-google-map";

const history = createHashHistory();

let isLoading = "false",
  userID = "";

class SampleVoucher extends Component {
  constructor(props) {
    super(props);
    this.state = {
      path: ["Home", "View Contract"],
      sampleData: "",
      show: false,
      alertMessage: "",
      deallist: "",
      dealID: ""
    };
    this.handleDismiss = this.handleDismiss.bind(this);
    this.handleShow = this.handleShow.bind(this);
  }

  handleDismiss() {
    this.setState({ show: false });
  }

  handleShow() {
    this.setState({ show: true });
  }

  componentWillMount() {
    this.handleDismiss();
    this.props.clearAlert();
    // isLoading='true';
    let dealID = this.props.match.params.dealID
      ? this.props.match.params.dealID
      : "";
    userID = this.props.match.params.userID
      ? this.props.match.params.userID
      : "";
    this.props.getDealDetail(dealID);
  }

  componentWillReceiveProps(nextProps) {
    if (this.props.dealDetail !== nextProps.dealDetail) {
      if (nextProps.dealDetail) {
        isLoading = "false";
        this.setState({ sampleData: nextProps.dealDetail });
      }
    }
    if (this.props.error !== nextProps.error) {
      if (nextProps.error) {
        isLoading = "false";
        this.props.clearAlert();
        this.handleShow();
        this.props.renderAlert("warning", nextProps.error);
      }
    }
    if (nextProps.message) {
      this.setState({
        alertMessage: nextProps.message,
        msgType: nextProps.alertType
      });
    }
  }

  render() {
    let sample = this.state.sampleData ? this.state.sampleData : [];
    return (
      <div className="col-lg-12 add-sub-admin">
        {this.state.show &&
          this.state.alertMessage !== "" && (
            <div className="col-lg-12">
              <Alert
                bsStyle={this.state.msgType}
                onDismiss={this.handleDismiss}
              >
                <strong>{this.state.msgType}:</strong> {this.state.alertMessage}
              </Alert>
            </div>
          )}
        <div className="panel">
          <div className="text-left">
            <span style={{ fontSize: "50px" }}>
              {" "}
              <b> #000000 </b>{" "}
            </span>
          </div>
          <div className="text-right">
            <img src="http://chart.apis.google.com/chart?cht=qr&chs=120x120&chld=L|1&chl=" />
          </div>
        </div>

        <div className="panel">
          <div className="text-center">
            <FormGroup controlId="formdeallist">
              <ControlLabel> {sample.dealText} </ControlLabel>
            </FormGroup>
          </div>
        </div>

        <div className="panel">
          <div className="panel-body">
            <div className="add-city col-lg-12 col-md-12 col-sm-12 col-xs-12">
              <Row>
                <Col md={4} xs={12}>
                  <FormGroup controlId="formdeallist1">
                    <ControlLabel> Purchased by </ControlLabel>
                  </FormGroup>
                  <FormGroup controlId="formdeallist2">
                    <ControlLabel> Expiration </ControlLabel>
                  </FormGroup>
                  <FormGroup controlId="formdeallist3">
                    <ControlLabel> Terms </ControlLabel>
                  </FormGroup>
                  <FormGroup controlId="formdeallist4">
                    <ControlLabel> Redemption </ControlLabel>
                  </FormGroup>{" "}
                  <br />
                  <FormGroup controlId="formdeallist5">
                    <ControlLabel> Notes </ControlLabel>
                  </FormGroup>
                </Col>

                <Col md={8} xs={12}>
                  <FormGroup controlId="formdeallist6">
                    <p> Customer's Name </p>
                  </FormGroup>
                  <FormGroup controlId="formdeallist7">
                    <p>
                      {" "}
                      {moment(sample.expiryDateTime).format("DD-MM-YYYY")}{" "}
                    </p>
                  </FormGroup>
                  <FormGroup controlId="formdeallist8">
                    <p>
                      {" "}
                      Limit {sample.maxPerCustomer} per customer, may purchase{" "}
                      {sample.maxAsGift} additional as gifts.
                      {sample.termsAndConditions}{" "}
                    </p>
                  </FormGroup>
                  <div className="text-left">
                    <Row>
                      <Col md={4} xs={8}>
                        {sample.merchantName} <br />
                        {sample.address1} <br />
                        {sample.city}, {sample.state} {sample.zipcode} <br />
                        {sample.phone}
                      </Col>
                      <Col md={4} xs={8}>
                        <StaticGoogleMap size="400x100">
                          <Marker.Group iconURL="https://chart.apis.google.com/chart?chst=d_map_pin_icon%26chld=cafe%257C996600">
                            <Marker location={sample.city} />
                            <Marker location={sample.state} />
                            {/* <Marker location="700+E+9th+St+NY" /> */}
                          </Marker.Group>
                        </StaticGoogleMap>
                      </Col>
                    </Row>
                  </div>
                  <FormGroup controlId="formdeallist10">
                    <p>
                      Product will be shipped automatically to the address
                      entered at checkout.
                    </p>
                  </FormGroup>
                </Col>
              </Row>
            </div>
          </div>
        </div>

        <div className="panel">
          <div className="panel-body">
            <Row>
              <Col md={6} xs={12}>
                <FormGroup controlId="formdeallist">
                  <ControlLabel> How to be a great customer </ControlLabel>
                </FormGroup>
                <br />
                <p>
                  {" "}
                  Be mindful of the expiration. Businesses will expect you to
                  show up before the expiration and will staff up accordingly so
                  you have the best experience.
                </p>
              </Col>

              <Col md={6} xs={12}>
                <FormGroup controlId="formdeallist">
                  <ControlLabel> Need Help? </ControlLabel>
                </FormGroup>
                <br />
                <p>
                  {" "}
                  Visit our Frequently Asked Questions at <b> {} </b>
                </p>
              </Col>
            </Row>
          </div>
        </div>

        <Row className="BtnRow">
          <Col md={12} xs={12}>
            {userID !== "" ? (
              <Button
                bsStyle="info"
                onClick={() => history.push(`/merchant/voucher/list/${userID}`)}
              >
                Back
              </Button>
            ) : (
              <Button
                bsStyle="info"
                onClick={() => history.push(`/merchant/voucher/list`)}
              >
                Back
              </Button>
            )}
          </Col>
        </Row>
      </div>
    );
  }
}

const mapStateToProps = (state, ownProps) => {
  return {
    dealDetail: state.dealReducer.dealDetail,
    alertType: state.alertsReducer.alertType,
    message: state.alertsReducer.message,
    error: state.dealReducer.error
  };
};

export default compose(
  withRouter, // IMPORTANT: witRouter is "needed here" to avoid blocking routing:
  connect(mapStateToProps, { renderAlert, clearAlert, getDealDetail })
)(SampleVoucher);



// WEBPACK FOOTER //
// ./src/app/views/merchant/voucher/SampleVoucher.js